import { cx } from './ui';

/** The legal pages live on the marketing site, not in the app. */
export const TERMS_URL = 'https://slatevideo.com/terms';
export const PRIVACY_URL = 'https://slatevideo.com/privacy';

const LINK = 'text-chalk-dim underline underline-offset-2 hover:text-chalk';

/**
 * The line under every way of creating an account: by doing so you agree
 * to the terms and the privacy policy. Same words everywhere Slate runs.
 */
export function LegalNotice({ action = 'creating an account', className }: { action?: string; className?: string }) {
  return (
    <p className={cx('text-caption text-chalk-faint', className)}>
      By {action} you agree to the{' '}
      <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" className={LINK}>
        Terms of Service
      </a>{' '}
      and{' '}
      <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" className={LINK}>
        Privacy Policy
      </a>
      .
    </p>
  );
}
